<form novalidate="novalidate" [formGroup]="form" autocomplete="off">
    <div class="well">
        <h2>Financial Receipt History <b>(for {{customerAccountType}} {{customerAccountNumberId}})</b></h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="fromDate">Start</label>
                    <p-calendar id="fromDate" [showIcon]="true" formControlName="fromDate"></p-calendar>
                    <control-validation-messages control="fromDate"></control-validation-messages>
                </div>

                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="toDate">End</label>
                    <p-calendar id="toDate" [showIcon]="true" formControlName="toDate" [placeholder]="'Today'"></p-calendar>
                    <control-validation-messages control="toDate"></control-validation-messages>
                </div>
                <div class="col-sm-3 col-md-3 mvd_form-group">
                    <label for="businessUnit">Business Unit</label>
                    <p-dropdown [options]="businessUnits" formControlName="businessUnitId" filter="filter"></p-dropdown>
                </div>

                <div class="col-sm-3 col-md-3 mvd_form-group">
                    <label for="businessTransactionTypeId">Business Transaction Type</label>
                    <p-dropdown [options]="businessTransactionTypes" formControlName="businessTransactionTypeId" filter="filter"></p-dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="receiptId">Receipt #</label>
                    <div class="">
                        <input class="mvd_form-control" id="receiptId" type="number" formControlName="receiptId" />
                    </div>
                    <control-validation-messages control="receiptId"></control-validation-messages>
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="minAmount">Minimum Amount</label>
                    <p-inputNumber formControlName="minAmount" mode="currency" currency="USD" placeholder="$0.00" />
                    <control-validation-messages control="minAmount"></control-validation-messages>
                </div>
                <div class="col-sm-3 col-md-2 mvd_form-group">
                    <label for="maxAmount">Maximum Amount</label>
                    <p-inputNumber formControlName="maxAmount" mode="currency" currency="USD" placeholder="$0.00" />
                    <control-validation-messages control="maxAmount"></control-validation-messages>
                    <div class="mvd_alert__validation" *ngIf="form.hasError('maxAmountLessThanMin')">
                        <div class="mvd_alert__rule">Maximum Amount cannot be less than the Minimum Amount</div>
                    </div>
                </div>
            </div>
        </fieldset>

        <div class="well__footer">
            <div class="btn--group">
                <button class="btn--default" type="button" (click)="reset()" [disabled]="inProgress">Reset</button>
                <button class="btn--primary" type="submit" (click)="submit()" [disabled]="inProgress">Find</button>
            </div>
        </div>

        <div class="divider" *ngIf="searchResults">
            <h2>
                Financial Receipt History Results ({{ dataStore.length }})  <button class="icon--download btn--default" type="button" (click)="exportAll()">Export All</button>
            </h2>
            <p-table #dt
                     styleClass="p-datatable-striped"
                     [value]="searchResults"
                     [columns]="cols"
                     [rows]="rows"
                     [paginator]="true"
                     [lazy]="true"
                     [totalRecords]="totalRecords"
                     [lazyLoadOnInit]="false"
                     (onLazyLoad)="loadDataLazy($event)"
                     [globalFilterFields]="['receiptId','financeDisbursementRequestId','businessTransactionNumberId', 'updatedDate','businessUnitName','customerName','businessTransactionTypeDisplayValue','amount','balance']"
                     >
                <ng-template pTemplate="caption">
                    <div class="row">
                        <div class="col-sm-6 col-md-3">
                            <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="7">
                            No Records Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-data>
                    <tr [pSelectableRow]="data">
                        <td>
                            <a *ngIf="data.type === 'receipt'" (click)="checkOutReceipt(data.receiptId)" href="javascript:void(0)">{{ data.receiptId }}</a>
                            <a *ngIf="data.type === 'disbursement'" (click)="viewDisbursementRequest(data.financeDisbursementRequestId)" href="javascript:void(0)">{{ data.financeDisbursementRequestId }}</a>
                        </td>
                        <td>{{data.businessTransactionNumberId}}</td>
                        <td>{{data.updatedDate | shortDate}}</td>
                        <td>{{data.businessUnitName}}</td>
                        <td class="td--hover-show">{{data.businessTransactionType}}</td>
                        <td class="td--hover-show">{{data.businessTransactionDetail}}</td>
                        <td>{{data.requestType}}</td>
                        <td>{{data.period}}</td>
                        <td class="text-right">{{data.amount | currency:'USD':'symbol-narrow':'.2-2' }}</td>
                        <td class="text-right">{{data.balance | currency:'USD':'symbol-narrow':'.2-2'}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</form>